import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Price } from '@grandvisionhq/common';

var ConfigurationTotalPrice = (_param)=> {
    var { originalPrice , discountedPrice , pricePrefix  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "originalPrice",
        "discountedPrice",
        "pricePrefix"
    ]);
    return React.createElement("div", {
        className: "configuration-total-price-wrapper"
    }, discountedPrice && discountedPrice !== originalPrice && /*#__PURE__*/ React.createElement(Price, swcHelpers.extends({}, rest, {
        type: "strikethrough",
        value: originalPrice,
        className: "configuration-total-price"
    })), /*#__PURE__*/ React.createElement(Price, swcHelpers.extends({}, rest, {
        value: discountedPrice !== null && discountedPrice !== void 0 ? discountedPrice : originalPrice,
        className: "configuration-total-price",
        type: discountedPrice ? 'discount' : 'default',
        prefix: pricePrefix
    })));
};

export { ConfigurationTotalPrice };
//# sourceMappingURL=ConfigurationTotalPrice.js.map
